import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "468px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
}))

export default styles
